import React, { useEffect, useRef } from 'react';
import { View, Animated, ScrollView, Dimensions } from 'react-native';
import Styles from './indexStyle';

type IProps = {
    type?: 'full' | 'part';
};

const Skeleton = (props: IProps) => {
    const { type = 'full' } = props;
    const opacityAnim = useRef(new Animated.Value(0)).current;
    const height = Dimensions.get('window').height;

    useEffect(() => {
        Animated.loop(
            Animated.sequence([
                Animated.timing(opacityAnim, {
                    toValue: 1,
                    duration: 600,
                    useNativeDriver: true,
                }),
                Animated.timing(opacityAnim, {
                    toValue: 0.6,
                    duration: 600,
                    useNativeDriver: true,
                }),
            ])
        ).start();
    }, [opacityAnim]);

    const mapLine = (num: number) =>
        Array.from({ length: num }).map((_, index) => <Animated.View key={index} style={[Styles.line, Styles.ske, { opacity: opacityAnim }]} />);
    if (type === 'part') {
        return (
            <View>
                <ScrollView style={{ height: height - 37 }} scrollEnabled={false}>
                    <View style={Styles.panel}>{mapLine(10)}</View>
                </ScrollView>
            </View>
        );
    }

    return (
        <View>
            <ScrollView style={{ height: height - 37 }} scrollEnabled={false}>
                <View style={Styles.container}>
                    <View style={[Styles.bigImg, Styles.ske]} />
                    <View style={Styles.panel}>
                        <View style={[Styles.header, Styles.ske]} />
                        {mapLine(3)}
                    </View>
                    <View style={Styles.panel}>
                        <View style={[Styles.shortheader, Styles.ske]} />
                        {mapLine(10)}
                    </View>
                </View>
            </ScrollView>
            <View style={{"position":"absolute","left":"0rem","right":"0rem","bottom":"0rem","height":"8.93719806763285rem"}}>
                <View style={Styles.option}>
                    <View style={[Styles.iconButton, Styles.ske]} />
                    <View style={[Styles.iconButton, Styles.ske]} />
                    <View style={[Styles.optButton, Styles.ske]} />
                </View>
            </View>
        </View>
    );
};

export default Skeleton;
